import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'environments/environment';

export interface TransferAccount {
  id: number;
  name: string;
}

@Injectable({ providedIn: 'root' })
export class AccountService {
  constructor(private http: HttpClient) {}

  public search(query: string): Observable<TransferAccount[]> {
    return this.http.post<{ content: TransferAccount[] }>(
      `${environment.api_url}/admin/account/search`,
      { accountName: query },
      {
        params: { page: '0', size: '20', sort: 'name,asc' },
        headers: { 'Time-Zone': Intl.DateTimeFormat().resolvedOptions().timeZone }
      }
    ).pipe(map(response => response.content));
  }
}
